import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FundadminRoutingModule } from './fundadmin-routing.module';
import { FundadminComponent } from './components/fundadmin.component';
import { TranslateModule } from '@ngx-translate/core';
import { FundadminService } from './services/fundadmin.service';
import { WindowRef } from '../../shared/services/window.service';
import { MyDatePickerModule } from 'mydatepicker';
import { DpDatePickerModule } from 'ng2-date-picker';
import { FundPerformanceResourceService } from '../../shared/services/fund-performance-resource.service';
import { FundPerformanceResourceApi } from '../../shared/services/api/fund-performance-resource.api';
import { BsModalModule } from 'ng2-bs3-modal';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FundadminRoutingModule,
    MyDatePickerModule,
    DpDatePickerModule,
    BsModalModule,
    ReactiveFormsModule,
    TranslateModule.forChild()
  ],
  declarations: [FundadminComponent],
  exports: [FormsModule, ReactiveFormsModule],
  providers: [FundadminService, FundPerformanceResourceService, WindowRef, FundPerformanceResourceApi]
})
export class FundadminModule {
}
